import React from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import PageHeader from "@/components/common/PageHeader";

const TABS = [
  { to: "/app/companies", label: "Groupe", end: true, key: "groupe" },
  { to: "/app/companies/entities", label: "Entités", key: "entities" },
  { to: "/app/companies/orgchart", label: "Organigramme", key: "orgchart" },
  { to: "/app/companies/flows", label: "Flux financiers", key: "flows" },
];

export default function CompaniesShell() {
  const location = useLocation();
  // Hide the shell when we're on the detail page /app/companies/:id (id != known tabs)
  const knownTabs = ["", "entities", "orgchart", "flows"];
  const parts = location.pathname.replace("/app/companies", "").split("/").filter(Boolean);
  const isDetail = parts.length >= 1 && !knownTabs.includes(parts[0]);
  if (isDetail) return <Outlet />;

  return (
    <div className="animate-fade-up">
      <PageHeader
        overline="Groupe & sociétés"
        title="Structure du groupe"
        description="Toutes les entités juridiques, participations, flux financiers et indicateurs consolidés."
      />
      <div className="border-b border-border mb-8">
        <nav className="-mb-px flex flex-wrap gap-6">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.end}
              data-testid={`companies-tab-${t.key}`}
              className={({ isActive }) =>
                `pb-3 text-sm font-medium border-b-2 transition-colors ${
                  isActive
                    ? "border-primary text-foreground"
                    : "border-transparent text-muted-foreground hover:text-foreground"
                }`
              }>
              {t.label}
            </NavLink>
          ))}
        </nav>
      </div>
      <Outlet />
    </div>
  );
}
